export default {
  roadFirstCountries: ['AT', 'DE', 'BE', 'NL', 'IT', 'DK', 'ES', 'PT', 'SE']
}
